import React, { useContext, useEffect, useState } from "react";
import styled from "styled-components";
import moment from "moment";
import { Grid } from "@mui/material";

import { FlexContainer, Text } from "src/components";
import { SocialMediaButton, Container, FlexRow } from "./AccountLinkingPage";
import { AccountLinkingContext } from "./AccountLinkingContext";
import { getLinkedInOauthUrl } from "./utils/oauth";

import SocialMediaRow from "./AccountLinkingSocialMediaRow";
import NoAccountsLinked from "./NoAccountsLinked";

// Images
import FacebookIcon from "src/img/noticeboard/facebook.svg";
import LinkedInIcon from "src/img/noticeboard/linkedin.svg";
import LinkedInColoredIcon from "src/img/noticeboard/linkedin_colored.svg";
import InstagramIcon from "src/img/noticeboard/instagram.svg";
import { SocialMediaPlatform, SocialMediaPlatformColors } from "./utils/Enums";
import { getInstagramOauthUrl } from "./utils/oauth";
import OauthPopup from "./components/OauthPopup";
import { identifyPlatformLogo } from "../NoticeboardLinkedSocialItems";

const SocialMediaDivider = styled.div`
    width: 100%;
    height: 30px;
    background-color: #D8DEEC;
    border: 1px solid #D8DEEC;
    text-align: left;
    align-content: center;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
`;

const SocialMediaPageCard = styled.div`
    width: auto;
    background: #F4F5F8 0% 0% no-repeat padding-box;
    box-shadow: 0px 3px 6px #00000029;
    border: 1px solid #D8DEEC;
    border-radius: 7px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    margin: 20px;
`;

const ConnectedPagesSection = (props) => {
    const {
        linkedItem,
        platformMainIcon,
        isExpired,
    } = props;
    const pages = linkedItem.pages.flat();
    let mediaTypeColors = SocialMediaPlatformColors.FACEBOOK;


    switch (linkedItem.pageAdmin.socialMediaType) {
        case SocialMediaPlatform.FACEBOOK:
            mediaTypeColors = SocialMediaPlatformColors.FACEBOOK;
            break;
        case SocialMediaPlatform.INSTAGRAM:
            mediaTypeColors = SocialMediaPlatformColors.INSTAGRAM;
            break;
        case SocialMediaPlatform.LINKEDIN:
            mediaTypeColors = SocialMediaPlatformColors.LINKEDIN;
            break;
        default:
            break;
    }

    const pagePlatformType = linkedItem.pageAdmin.socialMediaType;
    const [validAdminPhoto, setValidAdminPhoto] = useState(null);
    const defaultPlatformLogo = identifyPlatformLogo(pagePlatformType);
    const adminLogo = linkedItem.pageAdmin?.profilePhoto ? linkedItem.pageAdmin?.profilePhoto : platformMainIcon;

    useEffect(() => {
        const img = new Image();
        img.src = adminLogo;

        img.onload = () => {
            setValidAdminPhoto(adminLogo);
        };

        img.onerror = () => {
            setValidAdminPhoto(platformMainIcon);
        };
    }, [adminLogo]);

    return (
        <FlexContainer flexGrow="1" direction="column" tDirection="column" mDirection="column"> {/** Left side, profile name and pages */}
            <Container style={{ marginBottom: "10px" }}>
                <FlexRow>
                    <SocialMediaButton width="267px" backgroundColor={mediaTypeColors}>
                        <img src={validAdminPhoto} alt="Platform Icon" style={{ marginRight: "12px", borderRadius: "50%", width: "33.346px", height: "33.346px" }} /> {/** TODO: display/save profile photo here */}
                        {linkedItem.pageAdmin?.accountName}
                    </SocialMediaButton>
                </FlexRow>
            </Container>
            {
                pages.map((pageItem) => {
                    const [validPagePhoto, setValidPagePhoto] = useState(null);
                    const pageLogo = pageItem.pagePhoto ? pageItem.pagePhoto : defaultPlatformLogo;

                    useEffect(() => {
                        const img = new Image();
                        img.src = pageLogo;

                        img.onload = () => {
                            setValidPagePhoto(pageLogo);
                        };

                        img.onerror = () => {
                            setValidPagePhoto(defaultPlatformLogo);
                        };
                    }, [pageLogo]);

                    return (
                        <SocialMediaRow
                            key={pageItem.uuid}
                            pageItem={pageItem}
                            logo={validPagePhoto}
                            isExpiredPage={isExpired}
                        />
                    );
                })
            }
        </FlexContainer>
    );
};

const BusinessPortalDetailsAndActionsSection = (props) => {
    const {
        linkedItem,
        isExpired,
        platform,
        handleFacebookReconnect,
        handleInstagramReconnect,
        revokeSocialMediaAccount
    } = props;

    const isFacebook = platform === SocialMediaPlatform.FACEBOOK;
    const isInstagram = platform === SocialMediaPlatform.INSTAGRAM;
    const isLinkedIn = platform === SocialMediaPlatform.LINKEDIN;

    const buttonColor = isExpired ? "#fff" : "#000";
    const textColor = isExpired ? "#000" : "#fff";
    const border = isExpired ? "1px solid #000000" : "";
    const label = isExpired ? "Reconnect" : "Disconnect";

    return (
        <FlexContainer direction="column" tDirection="column" mDirection="column">
            <Grid
                container
                direction="column"
                justifyContent="flex-end"
                alignItems="flex-end"
                style={{ padding: "0px 1.438rem 20px 20px" }}
            >
                <Grid item>
                    <Text size="0.938rem" weight="500" align="right">
                        Added by {linkedItem.pageAdmin.employeeName}
                    </Text>
                </Grid>
                <Grid item>
                    { !isExpired &&
                        <SocialMediaButton
                            width="125px"
                            height="39px"
                            border={border}
                            backgroundColor={buttonColor}
                            color={textColor}
                            padding="unset !important"
                            style={{ justifyContent: "center" }}
                            onClick={() => revokeSocialMediaAccount(linkedItem.pageAdmin.uuid, linkedItem.pageAdmin.socialMediaType)}
                        >
                            {label}
                        </SocialMediaButton>
                    }
                    { isExpired && <>
                        { isFacebook &&
                            <SocialMediaButton
                                width="125px"
                                height="39px"
                                border={border}
                                backgroundColor={buttonColor}
                                color={textColor}
                                padding="unset !important"
                                style={{ justifyContent: "center" }}
                                onClick={() => handleFacebookReconnect(linkedItem.pageAdmin.uuid)}
                            >
                                {label}
                            </SocialMediaButton>
                        }
                        { isInstagram &&
                            <OauthPopup
                                url={getInstagramOauthUrl()}
                                onCode={oauthCode => handleInstagramReconnect(oauthCode, linkedItem.pageAdmin.uuid)}
                                onClose={() => "" }
                            >
                                <SocialMediaButton
                                    width="125px"
                                    height="39px"
                                    border={border}
                                    backgroundColor={buttonColor}
                                    color={textColor}
                                    padding="unset !important"
                                    style={{ justifyContent: "center" }}
                                >
                                    {label}
                                </SocialMediaButton>
                            </OauthPopup>
                        }
                        { isLinkedIn &&
                            <a href={getLinkedInOauthUrl()} style={{ textDecorationLine: "none" }}>
                                <SocialMediaButton
                                    width="125px"
                                    height="39px"
                                    border={border}
                                    backgroundColor={buttonColor}
                                    color={textColor}
                                    padding="unset !important"
                                    style={{ justifyContent: "center" }}
                                >
                                    {label}
                                </SocialMediaButton>
                            </a>
                        }
                    </> }
                </Grid>
            </Grid>
        </FlexContainer>
    );
};

const DisplayLinkedItems = ({
    linkedItems,
    platformMainIcon,
    revokeSocialMediaAccount,
    handleFacebookReconnect,
    handleInstagramReconnect,
    platform
}) => {
    const today = moment().startOf("day");
    const isAccountAccessExpired = (expiryDate) => {
        return expiryDate && moment(expiryDate).isBefore(today);
    };
    return (
        <>
            {
                linkedItems.map((linkedItem, index) => {
                    const isExpired = isAccountAccessExpired(linkedItem.pageAdmin.expiryDate);
                    return (
                        <SocialMediaPageCard key={index}>
                            <FlexContainer
                                overflowX="auto" wrap="wrap"
                                direction="row" mDirection="col" tDirection="col"
                                width="100%" tWidth="100%" mWidth="100%"
                            >
                                {/** Left side, profile name and pages */}
                                <ConnectedPagesSection
                                    linkedItem={linkedItem}
                                    platformMainIcon={platformMainIcon}
                                    isExpired={isExpired}
                                />
                                {/** Right side, business portal username action button */}
                                <BusinessPortalDetailsAndActionsSection
                                    linkedItem={linkedItem}
                                    isExpired={isExpired}
                                    platform={platform}
                                    handleFacebookReconnect={handleFacebookReconnect}
                                    handleInstagramReconnect={handleInstagramReconnect}
                                    revokeSocialMediaAccount={revokeSocialMediaAccount}
                                />
                            </FlexContainer>
                        </SocialMediaPageCard>
                    );
                })
            }
        </>
    );
};

const AccountsLinked = (props) => {
    const {
        linkedAccounts,
        revokeSocialMediaAccount,
        handleFacebookReconnect,
        handleInstagramReconnect
    } = props;


    const {
        showAccountsLinked,
        totalFacebookAccounts,
        totalInstagramAccounts,
        totalLinkedinAccounts,
        hasLinkedFacebookAccounts,
        hasLinkedInstagramAccounts,
        hasLinkedLinkedinAccounts,
    } = useContext(AccountLinkingContext);

    if (!hasLinkedFacebookAccounts &&
        !hasLinkedInstagramAccounts &&
        !hasLinkedLinkedinAccounts &&
        showAccountsLinked) {
        return (
            <NoAccountsLinked />
        );
    }

    return (
        <div style={{ margin: "30px 0px 0px 0px" }}>
            <Text size="20px" weight="700" align="left" margin="0 0 20px 40px">Connected Accounts:</Text>
            <SocialMediaDivider>
                <Text size="15px" weight="500" align="left" margin="auto 0 auto 40px" color="#fff">Facebook Accounts</Text>
                <Text size="15px" weight="500" align="right" margin="auto 26px auto 0" color="#fff">{totalFacebookAccounts}</Text>
            </SocialMediaDivider>
            {hasLinkedFacebookAccounts &&
                <DisplayLinkedItems
                    linkedItems={linkedAccounts?.Facebook}
                    platformMainIcon={FacebookIcon}
                    platform={SocialMediaPlatform.FACEBOOK}
                    revokeSocialMediaAccount={revokeSocialMediaAccount}
                    handleFacebookReconnect={handleFacebookReconnect}
                    handleInstagramReconnect={handleInstagramReconnect}
                />
            }
            {!hasLinkedFacebookAccounts && <NoAccountsLinked />}

            <SocialMediaDivider>
                <Text size="15px" weight="500" align="left" margin="auto 0 auto 40px" color="#fff">Instagram Accounts</Text>
                <Text size="15px" weight="500" align="right" margin="auto 26px auto 0" color="#fff">{totalInstagramAccounts}</Text>
            </SocialMediaDivider>
            {hasLinkedInstagramAccounts &&
                <DisplayLinkedItems
                    linkedItems={linkedAccounts?.Instagram}
                    platformMainIcon={InstagramIcon}
                    platform={SocialMediaPlatform.INSTAGRAM}
                    revokeSocialMediaAccount={revokeSocialMediaAccount}
                    handleFacebookReconnect={handleFacebookReconnect}
                    handleInstagramReconnect={handleInstagramReconnect}
                />
            }
            {!hasLinkedInstagramAccounts && <NoAccountsLinked />}

            <SocialMediaDivider>
                <Text size="15px" weight="500" align="left" margin="auto 0 auto 40px" color="#fff">LinkedIn Accounts</Text>
                <Text size="15px" weight="500" align="right" margin="auto 26px auto 0" color="#fff">{totalLinkedinAccounts}</Text>
            </SocialMediaDivider>
            {hasLinkedLinkedinAccounts &&
                <DisplayLinkedItems
                    linkedItems={linkedAccounts?.LinkedIn}
                    platformMainIcon={LinkedInIcon}
                    platformItemsIcon={LinkedInColoredIcon}
                    platform={SocialMediaPlatform.LINKEDIN}
                    revokeSocialMediaAccount={revokeSocialMediaAccount}
                    handleFacebookReconnect={handleFacebookReconnect}
                    handleInstagramReconnect={handleInstagramReconnect}
                />
            }
            {!hasLinkedLinkedinAccounts && <NoAccountsLinked />}
        </div>
    );
};

export default AccountsLinked;

